import { useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import alarmsActions from '@state/inverters/actions';

import arrayValueType from '@utils/dictionaries/arrayDataValueTypes';
import getColumnsDataInfo from './getColumnsDataInfo';

function useGroupCondition({ index }) {

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const orConditions = useSelector(({ inverters: a }) => a.createEditValues.conditions[index]);
  const isEditDefault = useSelector(({ inverters }) => inverters.isEditDefault);
  const columnsDataInfo = useMemo(() => getColumnsDataInfo({ t }), [t]);

  const { valueType } = arrayValueType;

  const removeGroupCondition = useCallback(() => {

    dispatch(alarmsActions.removeCreateEditValuesGroupConditions(index));
    // eslint-disable-next-line
  }, []);

  const addOrCondition = useCallback(() => {

    dispatch(alarmsActions.addOrCondition(index));///
    // eslint-disable-next-line
  }, []);

  useEffect(() => {

    if (orConditions.length === 0) addOrCondition();
    // eslint-disable-next-line
  }, []);

  return {
    removeGroupCondition,
    orConditions,
    addOrCondition,
    isEditDefault,
    columnsDataInfo,
    valueType,
  };

}

export default useGroupCondition;
